export function SET_PROFILE(state,data){
    state.data_profile = data
}